import { useCallback } from 'react';

import { MarginInstrument } from '@swyftx/margin/build/types';

import { api } from '@shared/api';
import { TimesEnum } from '@shared/enums';

import { useQuery } from '@tanstack/react-query';

import { useSwyftxMargin } from '../useSwyftxMargin';

const useFetchMarginInstruments = () => {
  const { swyftxMarginEnabled } = useSwyftxMargin();
  const fetchInstruments = useCallback(async (): Promise<MarginInstrument[]> => {
    const response = await api.endpoints.getMarginInstruments();
    return response.data;
  }, []);

  return useQuery({
    queryKey: ['margin-instruments'],
    queryFn: fetchInstruments,
    keepPreviousData: true,
    networkMode: 'always',
    staleTime: TimesEnum.SECOND * 60,
    enabled: swyftxMarginEnabled,
  });
};

export { useFetchMarginInstruments };
